import { IBatchJobSchedule } from "@mctypes/global.types";
import { Paper, Stack, Title } from "@mantine/core";
import React from "react";
import CheckOrWarn from "../CheckOrWarn";
import ScheduleSelector from "../ScheduleSelector/ScheduleSelector";

const ExportSchedule: React.FC<{
  scheduleOptions: IBatchJobSchedule;
  onSave: (jobEnabled: boolean, jobInterval: string) => void;
  isValid: boolean;
  disabled: boolean;
}> = ({ scheduleOptions, onSave, isValid, disabled }) => {
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>
          <CheckOrWarn bool={isValid} />
          Planlegging
        </Title>
        <Title order={6} fw={400} c="dimmed">
          Velg når og med hvilket intervall eksporten skal utføres
        </Title>
        <ScheduleSelector
          scheduleActive={scheduleOptions?.jobEnabled === true && disabled === false}
          onSave={onSave}
          expression={scheduleOptions?.jobInterval ?? ""}
          disabled={disabled}
        />
      </Stack>
    </Paper>
  );
};

export default ExportSchedule;
